import { render, staticRenderFns } from "./RequestTechAssistanceServices.vue?vue&type=template&id=cecb854a&scoped=true"
import script from "./RequestTechAssistanceServices.vue?vue&type=script&lang=js"
export * from "./RequestTechAssistanceServices.vue?vue&type=script&lang=js"
import style0 from "./RequestTechAssistanceServices.vue?vue&type=style&index=0&id=cecb854a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecb854a",
  null
  
)

export default component.exports